/**
 * Plantão "Ocupado sem identificação" — tipos do contrato compartilhado
 * (`docs/discovery/unidentified-coverage/plans/CONTRACT.md` no repo backend).
 *
 * Todos os campos são OPCIONAIS de propósito: backend anterior à feature não os
 * devolve e a UI se comporta como hoje (vaga = plantão sem médico).
 */
export enum CoverageStatus {
  OPEN = 'OPEN',
  DOCTOR = 'DOCTOR',
  UNIDENTIFIED = 'UNIDENTIFIED'
}

/** Motivo de bloqueio da transição para UNIDENTIFIED devolvido pelo preview do lote. */
export type CoverageBlockedReason = 'ANTECIPE' | 'CHECKIN' | 'POST_STATION_APPROVED'

/** Campos aditivos em todo payload que hoje expõe médico/vaga. */
export interface CoverageFields {
  coverageStatus?: CoverageStatus
  coverageResponsibleId?: number | null
  coverageResponsibleName?: string | null
  coverageNote?: string | null
  unregisteredDoctor?: boolean
}

export interface CoverageCounts {
  OPEN: number
  DOCTOR: number
  UNIDENTIFIED: number
}

export interface CoverageResponsibleResponse {
  id: number
  name: string
  isActive: boolean
  isSystem: boolean
  futureStationsCount: number
}

export interface UnregisteredCoverageCountResponse {
  future: number
  past: number
}
